import React from 'react';
import { useTranslation } from 'react-i18next';
import './RepairPlanButton.scss';
import constants from '~/utils/constants';
import { useRepairPlan } from '~/hooks/useRepairPlan';
import TooltipButton, { TooltipButtonVariants } from '../TooltipButton';

const {
    REASSIGN_STOP,
    UNASSIGN_STOP,
    RESEQUENCE_STOP,
    REASSOCIATE_DRIVER_VEHICLE,
    APPEND_ROUTE,
    CHANGE_DRIVER,
    OPTIMIZE_ROUTE,
    DELETE_BREAK,
    ADD_BREAK,
    RESEQUENCE_BREAK,
    EDIT_BREAK_DURATION
} = constants.processIndicator;
const supportedTypes = [
    REASSIGN_STOP,
    UNASSIGN_STOP,
    RESEQUENCE_STOP,
    REASSOCIATE_DRIVER_VEHICLE,
    APPEND_ROUTE,
    CHANGE_DRIVER,
    OPTIMIZE_ROUTE,
    DELETE_BREAK,
    ADD_BREAK,
    RESEQUENCE_BREAK,
    EDIT_BREAK_DURATION
];

type IndicatorType = (typeof supportedTypes)[number];
type RepairButtonProps = {
    indicatorType: IndicatorType;
};

export const RepairPlanButton = ({ indicatorType }: RepairButtonProps) => {
    const { repairPlan } = useRepairPlan();
    const { t } = useTranslation('common');

    if (!supportedTypes.includes(indicatorType)) {
        return null;
    }

    const repairPlanHandler = () => {
        repairPlan().catch((e) => console.error(e));
    };

    return (
        <div
            className="_d-flex repair-plan-button _ai-center _jc-center"
            data-testid="repair-plan-button"
        >
            <TooltipButton
                className="_text-2"
                onClick={repairPlanHandler}
                data-testid="repair-plan-button-button"
                variant={TooltipButtonVariants.LINK}
            >
                {t('repairPlan')}
            </TooltipButton>
        </div>
    );
};
